import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './assets/fonts.module.scss';
import './App.css';
import Home from './pages/Home/Home';

function App() {
  return (
    <Router>
      <div className="App">
        <div className='Header'>
          <h1>THE GENERATIVE PROJECT</h1>
        </div>
        <div className='Content'>
          <Routes>
            <Route path="/" element={<Home/>} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

// The page's scrollbar only shows while the page itself scrolls, hidden again after a second idle.
// Hidden by making it transparent (App.css) rather than turning scrolling off, so it keeps its
// space and nothing shifts. Scrolling inside a popup doesn't reach here: element scroll events
// don't bubble to the document.
let idleTimer: ReturnType<typeof setTimeout> | undefined;

function showScrollbar() {
  clearTimeout(idleTimer);
  document.documentElement.classList.remove('ScrollbarIdle');
  idleTimer = setTimeout(() => document.documentElement.classList.add('ScrollbarIdle'), 1000);
}

document.documentElement.classList.add('ScrollbarIdle');
document.addEventListener('scroll', showScrollbar);


export default App;
